import React from 'react'
import { Text } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'

const { lightGrey, red } = colors

type Props = {
    grades: Array<number>,
    selectedValue?: number,
    handleClick: number => void
}

const Grades = (props: Props) => {
    const { grades, handleClick, selectedValue } = props
    return (
        <Container>
            {grades.map((value, index) => (
                <Grade
                    key={index}
                    isSelected={value === selectedValue}
                    onClick={() => handleClick(value)}>
                    <Text>{value.toString()}</Text>
                </Grade>
            ))}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: space-around;
`

const Grade = styled.div`
    border: 1px solid;
    padding: 6px 15px;
    border-radius: 5px;
    margin: 5px;
    border-color: ${props => (props.isSelected ? red : lightGrey)};
    cursor: pointer;
`

export { Grades }
